import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";
import { Bell } from "@phosphor-icons/react";

const PREFS = [
  ["email_send_failure", "Échec d'envoi d'un email", "Être prévenu si un email de prospection n'a pas pu partir."],
  ["reply_received", "Réponse reçue", "Un décideur répond à l'un de vos emails."],
  ["opportunity_assigned", "Consultant positionné", "Un consultant est positionné sur une opportunité."],
  ["enrichment_completed", "Enrichissement terminé", "La recherche de contacts d'une entreprise est terminée."],
];

export default function NotificationsSettings() {
  const { user, refresh } = useAuth();
  const [prefs, setPrefs] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const p = user?.notification_prefs || {};
    const init = {};
    PREFS.forEach(([k]) => { init[k] = p[k] !== undefined ? !!p[k] : true; });
    setPrefs(init);
  }, [user]);

  const toggle = (k) => setPrefs((p) => ({ ...p, [k]: !p[k] }));

  const save = async () => {
    setSaving(true);
    try {
      await api.patch("/auth/profile", { notification_prefs: prefs });
      await refresh();
      toast.success("Préférences enregistrées ✅");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="notifications-page" className="max-w-2xl">
      <h1 className="font-display text-3xl font-bold">Notifications</h1>
      <p className="text-muted text-sm mt-1 mb-6">Choisissez les événements pour lesquels interKO vous alerte par email.</p>
      <div className="surface rounded-lg divide-y divide-border/50">
        {PREFS.map(([k, label, desc]) => (
          <div key={k} className="flex items-center justify-between gap-4 p-4" data-testid={`notif-row-${k}`}>
            <div className="flex items-start gap-3">
              <Bell size={16} className="text-accent mt-0.5" />
              <div><div className="text-sm text-fg font-medium">{label}</div><div className="text-xs text-muted">{desc}</div></div>
            </div>
            <Switch checked={!!prefs[k]} onCheckedChange={() => toggle(k)} data-testid={`notif-toggle-${k}`} />
          </div>
        ))}
      </div>
      <button onClick={save} disabled={saving} data-testid="notifications-save"
        className="mt-4 bg-accent text-black font-semibold px-5 py-2.5 rounded-md hover-lift disabled:opacity-60">
        {saving ? "Enregistrement…" : "Enregistrer les préférences"}
      </button>
    </div>
  );
}
